import * as React from 'react'
import { AccountSettingsMain } from './AccountSettingsMain'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const AccountSettingsMainExamples = () => {
  return (
    <div className="AccountSettingsMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <AccountSettingsMain />
      </Provider>
    </div>
  )
}
